import PropTypes from "prop-types";

export const ThemePropTypes = {
    logo: PropTypes.string,
    name: PropTypes.string,
    phone: PropTypes.string,
    user: PropTypes.object
};